import React, { useState } from 'react';
import Header from './Components/common/Header';
import Scroll from './Components/Scroll';
import Sidebar from './Components/common/Sidebar';
import { ProfileProvider } from './context/ProfileContext';
const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => { setIsSidebarOpen((prev) => !prev)};


    
    return (
        <ProfileProvider>
            <Scroll />
            <Header toggleSidebar={toggleSidebar} />
            <div className="container-scroller">
                <div className="container-fluid page-body-wrapper">
                    <Sidebar isOpen={isSidebarOpen}  toggleSidebar={toggleSidebar}/>
                    <div className="main-panel">
                        {children}
                    </div>
                </div>
            </div>
        </ProfileProvider>
    );
};

export default Layout;
